<template>
  <div>
    <div class="card">
      <div class="card-header">Criar Relatório de TimeSheet</div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-6">
            <b-form-group>
              <template slot="label">
                <b-badge variant="success">Cliente</b-badge>
                &nbsp;<span class="text-danger">*</span>
              </template>

              <v-select
                v-model="customerPk"
                :reduce="item => item.pk"
                label="social_name"
                placeholder="---------------------"
                :options="customers"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <template slot="label">
                Data inicial
                &nbsp;<span class="text-danger">*</span>
              </template>

              <datepicker
                v-model="startDate"
                format="dd/MM/yy"
                input-class="form-control"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <template slot="label">
                <b-badge variant="primary">Contrato</b-badge>
                &nbsp;<span class="text-danger">*</span>
              </template>

              <v-select
                v-model="contractPk"
                :reduce="item => item.pk"
                label="name"
                placeholder="---------------------"
                :options="contracts"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <template slot="label">
                Data final
                &nbsp;<span class="text-danger">*</span>
              </template>

              <datepicker
                v-model="endDate"
                format="dd/MM/yy"
                input-class="form-control"
              />
            </b-form-group>
          </div>

          <div class="col-12 col-md-6">
            <b-button variant="primary" @click="filterData()" :disabled="!(customerPk && contractPk)">Filtrar</b-button>
            <small v-if="timesheets_not_conferred" style="color: red; padding-left: 5px">* Existem lançamentos no TimeSheets que ainda não foram conferidos.</small>
          </div>
        </div>

        <div class="row" style="padding: 2rem 0;">
          <div class="col-12 col-md-6" v-if="contractInfo">
            <h5>Informações do contrato</h5> 
            <div>{{ contractTypes[contractInfo.contract_type] }}</div>
            <section v-if="(contractInfo.contract_type === 'p' || contractInfo.contract_type === 'h') && contractInfo.limit_hours">
              <div>
                Horas Contratadas: {{ contractInfo.limit_hours }}h
              </div>
            </section>
            <section v-if="contractInfo.contract_type === 'm' && contractInfo.limit_hours">
              <div>
                Teto de Horas: {{ contractInfo.limit_hours }}h
              </div>
            </section>
            <div v-if="totalHoursWorked">
              Horas trabalhadas: {{ totalHoursWorked }}h
            </div>
            <div v-if="contractInfo.timebank">
              Banco de horas {{ contractInfo.timebank}}h
            </div>
            <div v-if="contractInfo.is_timebank_charge_month">
              Observação: O banco de horas deste contrato deve ser cobrado este mês.
            </div>
              
            <div style="margin-top: 1rem">
              Mais informações: <a :href='`/contracts/${contractPk}`' target="_blank">{{ contractInfo.contract }} <i class="fa fa-external-link" style="font-size: .7rem"></i></a>
            </div>
          </div>
        </div>

        <div class="row">
          <div v-if="selected.length > 0" class="col-12 col-md-6">
            <div>
              <b-form-group>
                <template slot="label">
                  Vencimento
                  &nbsp;<span class="text-danger">*</span>
                </template>
                <datepicker
                  v-model="expireDate"
                  format="dd/MM/yy"
                  input-class="form-control"
                />
              </b-form-group>
            </div>
            <b-button variant="success" @click="generateReport">Gerar Relatório</b-button> <small> * Antes de continuar, verifique se todos os TimeSheets foram conferidos.</small>
          </div>
        </div>


        <b-table class="mt-3" striped selectable :items="items" :fields="tableFields" @row-selected="onRowSelected" ref="the_table" :tbody-tr-class="rowClass">
          <template v-slot:head(checkbox)="data">
            <b-form-checkbox @change="selectAll($event)" v-model="allSelected"></b-form-checkbox>
          </template>

          <template v-slot:cell(checkbox)="data">
            <b-form-checkbox :checked="data.rowSelected" @change="selectRow($event, data.index)"></b-form-checkbox>
          </template>

          <template v-slot:cell(timesheet_date)="data">
            {{ data.item.timesheet_date | formatDate }}
          </template>

          <template v-slot:cell(conferred)="data">
            <i class="fa" :class="data.item.conferred ? 'fa-check ok' : 'fa-close no'"></i>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import moment from 'moment';

import 'vue-select/dist/vue-select.css';

export default {
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      contractInfo: null,
      contracts: [],
      customers: [],
      timesheets_not_conferred: null,
      customerPk: null,
      contractPk: null,
      startDate: null,
      endDate: null,
      expireDate: null,
      tableFields: [
        {
          key: 'checkbox',
        },
        {

          key: 'pk',
          label: 'ID',
        },
        {
          key: 'timesheet_date',
          label: 'Data'
        },
        {
          key: 'customer.social_name',
          label: 'Cliente'
        },
        {
          key: 'contract.title',
          label: 'Contrato'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'timesheet_hours',
          label: 'Horas'
        },
        {
          key: 'employee.full_name',
          label: 'Funcionário'
        },
        {
          key: 'conferred',
          label: 'Conferido'
        },
      ],
      selected: [],
      allSelected: false,
      items: [],
      contractTypes: {
        'h': 'Por hora',
        'm': 'Mensal',
        'p': 'Projeto'
      }
    };
  },
  mounted() {
    this.$store.dispatch('customers/loadItems');

    const date = new Date();

    date.setHours(date.getHours() + date.getTimezoneOffset());

    this.startDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.endDate = date;
    this.expireDate = date;

    axios.get('/crm/customers/with-contract/')
    .then(response => {
      this.customers = response.data.data;
    });
  },
  watch: {
    customerPk(newVal, oldVal) {
      if (!newVal || newVal == oldVal) {
        return;
      }

      axios.get('/contract/?customer_pk=' + newVal)
        .then(res => {
          this.contracts = res.data.data.map(c => ({
            pk: c.pk,
            name: c.title,
          }));

          if (this.contracts.length > 0) {
            this.contractPk = this.contracts[0].pk;
          } else {
            this.contractPk = null;
          }

          this.$forceUpdate();
        });
    }
  },
  computed: {
    isChargeMonth() {
      return this.contractInfo && this.contractInfo.is_timebank_charge_month;
    },
    totalHoursWorked() {
      const totalMinutes = this.items.reduce((total, item) => {
        return total + this.timeToMinutes(item.timesheet_hours);
      }, 0);
      return this.minutesToTime(totalMinutes);
    },
  },
  methods: {
    timeToMinutes(timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
    },
    minutesToTime(minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
    },
    filterData() {
      // Start by fetching data from the API
      axios.get('/timesheet/without_report/', {
        params: {
          start_date: this.startDate.toISOString().split('T')[0],
          end_date: this.endDate.toISOString().split('T')[0],
          customer_pk: this.customerPk,
          contract_pk: this.contractPk,
        },
      })
      .then(response => {
        // Process the response data
        this.items = response.data.data;
        this.timesheets_not_conferred = response.data.timesheets_not_conferred;

        // Dispatch Vuex action after the axios call completes
        return this.$store.dispatch('timesheet_reports/getContractTimesheetInfo', {
          pk: this.contractPk,
          start_date: this.startDate.toISOString().split('T')[0],
          end_date: this.endDate.toISOString().split('T')[0],
        });
      })
      .then(response => {
        this.contractInfo = response;
        return this.contractInfo;
      })
      .catch(error => {
        // Handle any errors from either request
        console.error('Error:', error);
      });
    },
    generateReport() {
      try {
        axios.post('/timesheet/reports/gen_report/', {
          items: this.selected.map(s => s.pk),
          start_date: this.startDate.toISOString().split('T')[0],
          end_date: this.endDate.toISOString().split('T')[0],
          expiration_date: this.expireDate.toISOString().split('T')[0],
          customer_pk: this.customerPk,
          contract_pk: this.contractPk,
        })
        .then((response) => {
          if (response.data.error) {
            this.$swal('Erro ao Criar Relatório', response.data.error, 'error');
          } else if (response.status == 200) {
            this.$swal('Relatório Criado', 'Relatório criado com sucesso.', 'success');
            this.$router.push('/timesheet/report/detail/' + response.data.data);
          }
        })
        .catch(error => {
          this.$swal('Erro ao Criar Relatório', 'Tente novamente. Se o problema persistir, fale com o suporte.', 'error');
        })
      } catch (error) {
        this.$swal('Erro ao Criar Relatório', 'Tente novamente. Se o problema persistir, fale com o suporte.', 'error');
      }
    },
    onRowSelected(items) {
      this.selected = items;

      if (this.selected.length == this.items.length) {
        this.allSelected = true;
        return;
      }

      this.allSelected = false;
    },
    selectAll(event) {
      this.allSelected = event;

      const items = this.items;
      const theItems = [...items].map((item, i) => {
        return {
          ...item,
          index: i,
        }
      });

      const selectedPks = this.selected.map(s => s.pk);

      const indexes = theItems.filter(i => {
        if (event) {
          return !selectedPks.includes(i.pk);
        }

        return selectedPks.includes(i.pk);
      })
        .map(i => i.index);

      this.clickRows(indexes);
    },
    selectRow(event, i) {
      this.clickRows([i]);

      if (this.selected.length == this.items.length) {
        this.allSelected = true;
        return;
      }

      this.allSelected = false;
    },
    clickRows(which) {
      let myTable = this.$refs.the_table.$el,
          tableBody = myTable.getElementsByTagName('tbody')[0],
          tableRows = tableBody.getElementsByTagName('tr')
      which.forEach(idx => {
        tableRows[idx].click()
      })
    },
    rowClass(item, type) {
      if (!item.conferred) return 'table-danger'
    }
  }
}
</script>
